import React from 'react';
import { reduxForm, Field } from 'redux-form';

import FormError from 'components/FormError';
import InputField from 'components/InputField';
import FileInputField from 'components/FileInputField';

import styles from './styles.module.scss';

let MassActivationForm = ({ btnText, handleSubmit, error }) => {
  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.inputs}>
        <Field
          component={FileInputField}
          type="file"
          name="csv_file"
          label="CSV File*"
          accept=".csv"
        />
        <Field
          component={InputField}
          name="send_result_to"
          label="Send Result To"
        />
      </div>
      {error && <FormError error={error} />}
      <button className="btn btn-primary">
        {btnText ? btnText : 'Mass Activation'}
      </button>
    </form>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.csv_file) {
    errors.csv_file = 'Required';
  }

  return errors;
};

MassActivationForm = reduxForm({
  validate,
})(MassActivationForm);

export default MassActivationForm;
